import { Pipe, PipeTransform } from '@angular/core';
import { formatSeaweedPath, isAssistant } from './util';
import { isRetina } from '../utils/helpers';
import { AppRootContext } from '../bootstrap';

@Pipe({ name: 'avatarUrl' })
export class AvatarUrlPipe implements PipeTransform {
    constructor(private appRootContext: AppRootContext) {}

    private getSize(size, _isAssistant) {
        const _sizeArr = [40, 80, 160, 320];
        let result = size;
        if (_isAssistant && !isRetina()) {
            _sizeArr.unshift(24);
        }
        // default 40x40
        if (!size) {
            result = 40;
        } else if (_sizeArr.indexOf(parseInt(size, 10)) === -1) {
            for (let i = 0; i < _sizeArr.length; i++) {
                if (_sizeArr[i] >= size) {
                    result = _sizeArr[i];
                    break;
                }
            }
        }
        return result;
    }

    transform(avatar: string, size: number): string {
        const name = avatar ? avatar.split('.')[0] : '';
        const _isAssistant = isAssistant(name);
        if (!avatar || avatar === 'default.png') {
            return this.appRootContext.globalInfo.config.cdnRoot + `image/default_avatar.png`;
        } else {
            const _size = this.getSize(size, _isAssistant);
            if (this.appRootContext.globalInfo.config.isIndependent) {
                return this.appRootContext.globalInfo.config.box.avatarUrl + formatSeaweedPath(avatar, _size, _size);
            } else {
                const newAvatar = avatar.replace('.', `_${_size}x${_size}.`);
                return `${this.appRootContext.globalInfo.config.box.avatarUrl}${newAvatar}`;
            }
        }
    }
}
